module.exports = __webpack_public_path__ + "static/media/slakteweb-logo-white@2x.38408406.svg";